// extracted by mini-css-extract-plugin
export default {"root":"classes_root__DSJ5c","ended":"classes_ended__zpDfa","in_progress":"classes_in_progress__rmZk1","icon":"classes_icon__mE+h-","text":"classes_text__gDBBe"};